import React from "react";
import { connect } from "react-redux";
import { Box, makeStyles, Typography } from "@material-ui/core";
import DragItem from "../optimized/DragItem";
import {
  isNotEmptyRoute,
  secondsToTime,
  sortRouteGroupsFn
} from "../../utils/helpers";

const useStyles = makeStyles(theme => ({
  title: {
    pageBreakAfter: "avoid",
    marginBottom: theme.spacing(1)
  },
  subtitle: {
    fontSize: "1.25rem",
    marginBottom: theme.spacing(1)
  },
  pageBreak: {
    pageBreakAfter: "always"
  },
  shift: {
    marginBottom: theme.spacing(3),
    textAlign: "center"
  }
}));

function PrintRoutes({
  routeGroups,
  selectedRoutes,
  projectName,
  projectStatus,
  routeIds
}) {
  const classes = useStyles();

  const startEnd = type => type === "start" || type === "end";

  return Object.keys(routeGroups)
    .sort(sortRouteGroupsFn)
    .map(key => {
      return routeGroups[key].map(backhaulGroup => {
        const allStartEndStops = backhaulGroup
          .map(routeGroup => routeGroup.stops)
          .flat()
          .filter(stop => stop.type === "start" || stop.type === "end");

        const start =
          allStartEndStops[0]?.finish_time || allStartEndStops[0]?.end_time;
        const end = allStartEndStops[allStartEndStops.length - 1]?.arr_time;

        const startEndTime = [start, end];

        return backhaulGroup.map(route => {
          let count = 0;

          return (routeIds || selectedRoutes).includes(route.id) &&
            isNotEmptyRoute(route) ? (
            <Box px={3} className={classes.pageBreak}>
              <Typography className={classes.title} variant="h5" align="center">
                Project: {projectName || "Project name"}
              </Typography>
              <Box className={classes.shift}>
                <Typography variant="body1">
                  Shift: {secondsToTime(startEndTime[0])}-
                  {secondsToTime(startEndTime[1])}
                </Typography>
                <Typography variant="body1">
                  Driver:{" "}
                  {route.driver
                    ? route.driver.first_name + " " + route.driver.last_name
                    : ""}
                </Typography>
              </Box>
              <Box key={route.id} mb={3}>
                <Typography className={classes.subtitle} variant="h6">
                  {route.vehicle_name}
                </Typography>

                {route.stops.map((item, index) => {
                  if (!startEnd(item.type) && item.type !== "break") count++;
                  let number = count;
                  return (
                    <DragItem
                      key={item.id}
                      isStartEnd={startEnd(item.type)}
                      item={item}
                      index={index - 1}
                      count={number}
                      routeStatus={route.status}
                      container
                      projectStatus={projectStatus}
                      alignItems="center"
                      endLocationDefined={route.end_location_defined}
                      print
                    />
                  );
                })}
              </Box>
            </Box>
          ) : null;
        });
      });
    });
}

const mapStateToProps = state => ({
  routes: state.project.solution ? state.project.solution.routes : [],
  routeGroups: state.project.solution ? state.project.solution.routeGroups : {},
  selectedRoutes: state.common.selectedRoutes,
  projectStatus: state.project.status
});

export default connect(mapStateToProps)(PrintRoutes);
